/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#fff" active-text-color="#409eff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
	<div class="submenu" @click="exit()">退出</div>
	<div class="submenu" index="2-1" @click="unitpassword()">修改密码</div>
    <!-- <el-submenu index="2" class="submenu">
      <template slot="title">{{user.userRealName}}</template>
      <template slot="title" >超级管理员</template>
      <el-menu-item index="2-1">设置</el-menu-item>
      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item>
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu> -->
	<!-- 修改密码 -->
	<el-dialog title="修改密码" :visible.sync="editpassword" width="50%" @click='closeDialog("unit")'>
	  <el-form label-width="130px">
		  <el-form-item label="旧密码" >
		    <el-input size="medium" show-password auto-complete="off" v-model="oldPassword" placeholder="请输入旧密码"></el-input>
		  </el-form-item>
		  <el-form-item label="新密码" >
		    <el-input size="medium" show-password auto-complete="off" v-model="newPassword" placeholder="请输入新密码"></el-input>
		  </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button size="medium" @click='closeDialog("unit")'>取消</el-button>
	    <el-button size="medium" type="primary" class="title" @click="passworsave">保存</el-button>
	  </div>
	</el-dialog>
  </el-menu>
</template>
<script>
import { loginout,getpasswordchange } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
	  editpassword:false,
	  oldPassword:'',
	  newPassword:'',
      user: {},
	  userId:''
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
	this.userId = this.user.id
  },
  methods: {
	//修改密码
	unitpassword(){
	  this.editpassword = true
	},
	// 关闭编辑、增加弹出框
	closeDialog(dialog) {
	    this.editpassword = false
	 
	},
	passworsave(){
	  this.editpassword = false
	 getpasswordchange(this.userId,this.oldPassword,this.newPassword)
		 .then(res => {
		   if (res.success == false) {
			 this.$message({
			   type: 'info',
			   message: res.msg+'TraceId:'+res.traceId
			 })
		   } else {
			this.$message({
			  type: 'success',
			  message: '数据保存成功！'
			})
			
			}
		 })
		 .catch(error => {
		   this.$message.error('获取角色列表失败，请稍后再试！'+'TraceId:'+res.traceId)
		 }) 
	},
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
  height: 60px;
  line-height: 60px;
  margin-right: 40px;
  cursor: pointer;
  font-weight: bold;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue